import React from 'react';
import {useForm} from 'react-hook-form';

import Pagina, {CheckboxReactHookForm, esMayorOIgualACero} from "../comun/Pagina";
import SelectReactHookForm from "../comun/SelectReactHookForm";
import MensajeValidacion from "../comun/MensajeValidacion";

import efectosConstrucciones from '../../img/efectos_objetos_construcciones.png';
import PaginaAdelanteAtras from './PaginaAdelanteAtras';

export default function Pagina3(props) { 
    const materiales = [       
        {nombre: "No sé", codigo: 1},
        {nombre: "Adobe bahareque, tapia o roca", codigo: 2},
        {nombre: "Ladrillo", codigo: 3},
        {nombre: "Concreto reforzado", codigo: 4},
        {nombre: "Madera", codigo: 5},
        {nombre: "Acero", codigo: 6}
    ];

    const {register, handleSubmit, getValues, watch, formState:{errors}} = useForm();   

    /* refs y registros de react-hook-form*/
    const regSelMateriales = register("selMateriales", { required: dano==1});    

    const wdan = watch("dano");    
    var dano = null;    
    if (typeof(wdan) == 'undefined') {
        if (props.state.dano) {
            dano = props.state.dano;
        } else {
            dano = 0;
        }        
    } else {
        dano = wdan;
    }
    
    const validarDano = () => {
        let ids = ["tipo_danos_grietas_revest", "tipo_danos_caida_revest", "tipo_danos_caida_tejas", "tipo_danos_grietas_muros"];
        for (let i = 0; i < ids.length; i++) {
            if (document.getElementById(ids[i]).checked == true) {
                return true;
            }
        }
        return false;        
    }    
    
    return (
        <PaginaAdelanteAtras
        titulo="Efectos en objetos y construcciones"
        imgSrc={efectosConstrucciones}
        imgAlt="Efectos en construcciones"
        handleSubmit={handleSubmit}
        setState={props.setState}
        avanzarPagina={props.avanzarPagina}
        retrocederPagina={props.retrocederPagina}
        explicacion={
            <React.Fragment>
                Por favor selecciona los cambios que percibiste a tu alrededor, relacionados con movimiento, vibración o caída de objetos.
                <br/>Igualmente, reporta si observaste algún daño en la construcción en la que te encontrabas cuando ocurrió el sismo
            </React.Fragment>
        }
        
        contenidoPrincipal= {
            <React.Fragment>
                <div className="TextoMedianoVerde">Selecciona los efectos que observaste en los objetos a tu alrededor:</div>
                <div className='ContenedorHCentrado'>
                    <input type="checkbox" id="ef_balanceo" name="balanceo_colgantes" value="1" {...register("balanceo_colgantes")}
                    defaultChecked={props.state.balanceo_colgantes}/>
                    <label htmlFor="ef_balanceo">Balanceo de objetos colgantes</label><br/>
                </div>
                               
                <div className='ContenedorHCentrado'>
                    <input type="checkbox" id="ef_golpeteo" name="golpeteo_porcelana" value="1" {...register("golpeteo_porcelana")}
                    defaultChecked={props.state.golpeteo_porcelana}/>
                    <label htmlFor="ef_golpeteo">Ruido o golpeteo de vidrios o porcelanas</label><br/>
                </div>
                
                <div className='ContenedorHCentrado'>
                    <input type="checkbox" id="ef_vaiven" name="vaiven_puertas" value="1" {...register("vaiven_puertas")}
                    defaultChecked={props.state.vaiven_puertas}/>
                    <label htmlFor="ef_vaiven">Vaivén de puertas o ventanas</label><br/>
                </div>
                
                <div className='ContenedorHCentrado'>
                    <input type="checkbox" id="ef_oscilacion" name="oscilacion_liquidos" value="1" {...register("oscilacion_liquidos")}
                    defaultChecked={props.state.oscilacion_liquidos}/>
                    <label htmlFor="ef_oscilacion">Oscilación o vertimiento de líquidos</label><br/>
                </div>
                
                <div className='ContenedorHCentrado'>
                    <input type="checkbox" id="ef_susto_animales" name="reaccion_animales" value="1" {...register("reaccion_animales")}
                    defaultChecked={props.state.reaccion_animales}/>
                    <label htmlFor="ef_susto_animales">Reacción de susto en los animales</label><br/>
                </div>
                
                <div className='ContenedorHCentrado'>
                    <input type="checkbox" id="ef_caida" name="caida_pequenos" value="1" {...register("caida_pequenos")}
                    defaultChecked={props.state.caida_pequenos}/>
                    <label htmlFor="ef_caida">Caída o desplazamiento de objetos pequeños</label><br/>
                </div>
                
                <div className='ContenedorHCentrado'>
                    <input type="checkbox" id="ef_pesados" name="caida_pesados" value="1" {...register("caida_pesados")}
                    defaultChecked={props.state.caida_pesados}/>
                    <label htmlFor="ef_pesados">Caída o desplazamiento de objetos pesados como televisores, computadores, etc.</label>                    
                </div>
                <br/>

                <div className="TextoMedianoVerde">¿Hubo algún daño en la construcción donde te encontrabas?</div>
                <div className='ContenedorHCentrado'>
                    <input type="radio" id="danoSi" value="1" {...register("dano", {required: true})} defaultChecked={props.state.dano== 1}/>
                    <label htmlFor="danoSi">Sí</label>                
                    <div className='SeparadorHorizontal' />
                    <input type="radio" id="danoNo" value="0" {...register("dano", {required: true})} defaultChecked={props.state.dano== 0}/>
                    <label htmlFor="danoNo">No</label>
                </div>
                <MensajeValidacion nombre="dano" errors={errors}/>
                {(dano== 1) && (
                <React.Fragment>
                    <div>
                        <div className="TextoMedianoVerde">Material de la construcción averiada</div>
                        <SelectReactHookForm
                        id="selMateriales"
                        regSel ={regSelMateriales}
                        opciones={materiales}
                        errors={errors} 
                        valorDefault={props.state.selMateriales}
                        setState ={props.setState} />
                    </div>
                    
                    <div className="TextoMedianoVerde">Tipo de daño</div>
                    <div className='ContenedorHCentrado'>
                        <input type="checkbox" id="tipo_danos_grietas_revest" name="tipo_danos_grietas_revest" value="1" 
                        {...register("tipo_danos_grietas_revest", {validate: validarDano})} defaultChecked={props.state.tipo_danos_grietas_revest}/>
                        <label htmlFor="tipo_danos_grietas_revest">Grietas delgadas en el pañete o revestimiento</label><br/>
                    </div>
                    
                    <div className='ContenedorHCentrado'>
                        <input type="checkbox" id="tipo_danos_caida_revest" name="tipo_danos_caida_revest" value="2" 
                        {...register("tipo_danos_caida_revest", {validate: validarDano})} defaultChecked={props.state.tipo_danos_caida_revest}/>
                        <label htmlFor="tipo_danos_caida_revest">Caída de trozos de pañete</label><br/>
                    </div>
                    
                    <div className='ContenedorHCentrado'>
                        <input type="checkbox" id="tipo_danos_caida_tejas" name="tipo_danos_caida_tejas" value="2" 
                        {...register("tipo_danos_caida_tejas", {validate: validarDano})} defaultChecked={props.state.tipo_danos_caida_tejas}/>
                        <label htmlFor="tipo_danos_caida_tejas">Caída de tejas o chimeneas</label><br/>
                    </div>
                    
                    <div className='ContenedorHCentrado'>
                        <input type="checkbox" id="tipo_danos_grietas_muros" name="tipo_danos_grietas_muros" value="2" 
                        {...register("tipo_danos_grietas_muros", {validate: validarDano})} defaultChecked={props.state.tipo_danos_grietas_muros}/>
                        <label htmlFor="tipo_danos_grietas_muros">Grietas en muros</label>
                    </div>
                    
                    <MensajeValidacion nombre={"tipo_danos_grietas_revest"} errors={errors}/>
                </React.Fragment>
                )}
            </React.Fragment>
        }
        />
    );
}